<template>
  <q-dialog v-model="openDialog" persistent>
    <q-card class="scroll" style="width: 90%; max-width: 720px">
      <q-card-section class="row items-center no-wrap">
        <div class="text-h6">Mesclar cadastros</div>
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup :disable="salvando || carregando" />
      </q-card-section>

      <q-separator />

      <q-card-section v-if="carregando" class="text-center q-pa-lg">
        <q-spinner color="blue-7" size="3em" />
      </q-card-section>

      <q-card-section v-else-if="principal && duplicado" class="q-pa-md">
        <q-banner rounded class="bg-blue-1 text-blue-10 q-mb-md">
          <template v-slot:avatar>
            <q-icon name="info" color="blue-7" />
          </template>
          O cadastro <strong>#{{ principal.id }} {{ principal.nome }}</strong> será mantido.
          Tudo o que está no cadastro <strong>#{{ duplicado.id }} {{ duplicado.nome }}</strong>
          passa para ele, e o #{{ duplicado.id }} é excluído em seguida.
        </q-banner>

        <q-banner
          v-for="(aviso, i) in avisos"
          :key="'aviso' + i"
          rounded
          class="bg-negative text-white q-mb-md"
        >
          <template v-slot:avatar>
            <q-icon name="warning" color="white" />
          </template>
          <strong>Atenção!</strong> {{ aviso }}
        </q-banner>

        <div class="row q-col-gutter-md">
          <div class="col-12 col-sm-6">
            <q-card flat bordered>
              <q-card-section class="bg-positive text-white q-py-sm">
                <div class="text-subtitle2">Fica: #{{ principal.id }}</div>
              </q-card-section>
              <q-card-section>
                <div class="text-weight-bold">{{ principal.nome }}</div>
                <div>CPF/CNPJ: {{ principal.cpfcnpj || '(vazio)' }}</div>
                <div>E-mail: {{ principal.email || '(vazio)' }}</div>
                <div>{{ descreverTipos(principal) }}</div>
              </q-card-section>
            </q-card>
          </div>
          <div class="col-12 col-sm-6">
            <q-card flat bordered>
              <q-card-section class="bg-negative text-white q-py-sm">
                <div class="text-subtitle2">Será excluído: #{{ duplicado.id }}</div>
              </q-card-section>
              <q-card-section>
                <div class="text-weight-bold">{{ duplicado.nome }}</div>
                <div>CPF/CNPJ: {{ duplicado.cpfcnpj || '(vazio)' }}</div>
                <div>E-mail: {{ duplicado.email || '(vazio)' }}</div>
                <div>{{ descreverTipos(duplicado) }}</div>
              </q-card-section>
            </q-card>
          </div>
        </div>

        <div class="text-subtitle2 q-mt-md">Será transferido para o #{{ principal.id }}</div>
        <q-list dense v-if="resumo.length > 0">
          <q-item v-for="item in resumo" :key="item.descricao">
            <q-item-section>{{ item.descricao }}</q-item-section>
            <q-item-section side>
              <strong>{{ item.total }}</strong>
            </q-item-section>
          </q-item>
        </q-list>
        <div v-else class="text-grey-8">Nenhum registro vinculado ao cadastro #{{ duplicado.id }}.</div>

        <q-checkbox
          v-if="avisos.length > 0"
          v-model="confirmouAvisos"
          color="negative"
          class="q-mt-md text-weight-bold"
          label="Confirmo que os dois cadastros são da mesma pessoa ou empresa"
        />

        <div class="text-caption text-grey-8 q-mt-md">
          Os dados do #{{ principal.id }} são mantidos; só os campos vazios são preenchidos com os do
          #{{ duplicado.id }}. Os dados do cadastro excluído ficam registrados no histórico. Essa ação
          não pode ser desfeita.
        </div>
      </q-card-section>

      <q-card-actions align="right" v-if="!carregando && principal">
        <q-btn no-caps flat label="Cancelar" v-close-popup :disable="salvando" />
        <q-btn
          no-caps
          label="Mesclar cadastros"
          color="negative"
          text-color="white"
          :loading="salvando"
          :disable="avisos.length > 0 && !confirmouAvisos"
          @click="mesclar"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '@/axios-auth';
import { mensagemDeErro } from '@/utils/erros-api';

export default {
  name: 'modal-mesclar-cadastros',
  emits: ['atualizar'],
  data() {
    return {
      openDialog: false,
      carregando: false,
      salvando: false,
      ids: [],
      principal: null,
      duplicado: null,
      resumo: [],
      avisos: [],
      confirmouAvisos: false,
      // Numera as aberturas: resposta de uma abertura anterior não pode sobrescrever a atual.
      requisicao: 0,
    };
  },
  methods: {
    abrirModal(ids) {
      const requisicao = ++this.requisicao;
      this.ids = ids.slice();
      this.principal = null;
      this.duplicado = null;
      this.resumo = [];
      this.avisos = [];
      this.confirmouAvisos = false;
      this.openDialog = true;
      this.carregando = true;

      axios.post('/cadastros/mesclar', { ids: this.ids }).then(res => {
        if (requisicao !== this.requisicao) return;
        this.carregando = false;

        if (res.error) {
          this.openDialog = false;
          this.notificarErro(mensagemDeErro(res.error, 'mesclar os cadastros'));
          return;
        }

        if (!res.data.success) {
          this.openDialog = false;
          this.alertar(res.data.message, false);
          return;
        }

        this.principal = res.data.data.principal;
        this.duplicado = res.data.data.duplicado;
        this.resumo = res.data.data.resumo || [];
        this.avisos = res.data.data.avisos || [];
      });
    },
    mesclar() {
      this.salvando = true;

      axios.post('/cadastros/mesclar', { ids: this.ids, confirmar: true }).then(res => {
        this.salvando = false;

        if (res.error) {
          this.notificarErro(mensagemDeErro(res.error, 'mesclar os cadastros'));
          return;
        }

        this.alertar(res.data.message, res.data.success);

        if (res.data.success) {
          this.openDialog = false;
          this.$emit('atualizar');
        }
      });
    },
    descreverTipos(cadastro) {
      const tipos = [];
      if (cadastro.cliente) tipos.push('Cliente');
      if (cadastro.fornecedor) tipos.push('Fornecedor');
      if (cadastro.funcionario) tipos.push('Funcionário');
      if (!cadastro.ativo) tipos.push('Inativo');

      return tipos.join(' · ');
    },
    alertar(titulo, sucesso) {
      this.$q.dialog({
        title: titulo,
        class: `bg-${sucesso ? 'positive' : 'warning'} text-white`,
        ok: {
          'text-color': sucesso ? 'green' : 'orange',
          color: 'white',
        },
      });
    },
    notificarErro(message) {
      this.$q.notify({
        message,
        color: 'red',
        position: 'top-right',
      });
    },
  },
};
</script>
